import { addMonths, format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface MonthPickerProps {
  /** Mês em formato YYYY-MM */
  month: string;
  onChange: (month: string) => void;
}

export function MonthPicker({ month, onChange }: MonthPickerProps) {
  const date = parseISO(`${month}-01`);
  const go = (delta: number): void => {
    onChange(format(addMonths(date, delta), 'yyyy-MM'));
  };

  const label = format(date, "LLLL 'de' yyyy", { locale: ptBR });

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        size="icon"
        aria-label="Mês anterior"
        onClick={() => go(-1)}
      >
        <ChevronLeft className="h-5 w-5" />
      </Button>
      <span className="min-w-40 text-center text-base font-medium capitalize">
        {label}
      </span>
      <Button
        variant="ghost"
        size="icon"
        aria-label="Próximo mês"
        onClick={() => go(1)}
      >
        <ChevronRight className="h-5 w-5" />
      </Button>
    </div>
  );
}
